import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonFunctions } from '../shared/utilities/common-functions';
import { Router } from '@angular/router';
import { ShellService } from '../core/services/shell.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'CDMS-Portal-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    standalone: false
})
export class ShellComponent implements OnInit, OnDestroy {

  constructor(
    private readonly commonFunctions: CommonFunctions,
    private readonly router: Router,
    private readonly shellService: ShellService,
    private readonly toastr: ToastrService
  ) { }

  sideNavCollapse = false;
  firstmenuUrl = '';
  parentScreens: any = [];
  userHasNoAccess = false;

  private readonly _destroying$ = new Subject<void>();

  ngOnInit(): void {
    this.shellService.isShellDataLoaded$
    .pipe(
      takeUntil(this._destroying$)
    )
    .subscribe((loadData: boolean) => {
        if (loadData) {
          this.loadData();
        }
      }
    );

    this.shellService.sideNavCollapse$
    .pipe(
      takeUntil(this._destroying$)
    )
    .subscribe((value) => {
        this.sideNavCollapse = value;
        this.updateSideNavCollapseComputedStyle();
      }
    );

    this.shellService.companyChange$
    .pipe(
      takeUntil(this._destroying$)
    )
    .subscribe((value) => {
        if(value) {
          this.handleCompanyChangeOperations();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  /**
   * Handles computed styles not getting updated issue.
   * NOTE:
   * - This is a workaround for a known issue with CSS class toggling not reflecting immediately in some scenarios.
   * - If the issue still persists, Angular-driven approach should be considered.
   */
  private updateSideNavCollapseComputedStyle() {
    const sideNavElement = document.querySelector('.sidenavbar');
    if (sideNavElement) {
      if (this.sideNavCollapse) {
        (sideNavElement as HTMLElement).style.display = 'none';
      } else {
        (sideNavElement as HTMLElement).style.display = 'block';
      }
    }
  }

  private loadData() {
    this.firstmenuUrl = this.shellService.navigationData.firstmenuUrl;
    this.parentScreens = this.shellService.navigationData.parentScreens;
    if (this.router.url === '/') {
      this.router.navigate([this.firstmenuUrl]);
    }
  }

  private handleCompanyChangeOperations() {
    this.commonFunctions.showLoading();
    this.parentScreens = [];
    this.shellService.loadDataOnCompanyChange$()
    .pipe(
      takeUntil(this._destroying$),
      finalize(() => this.commonFunctions.hideLoading())
    )
    .subscribe({
      next: () => {
        this.router.navigate([this.firstmenuUrl]);
        this.parentScreens = this.shellService.navigationData.parentScreens;
        this.shellService.setFetchNotifications(true);
      },
      error: (error) => {
        this.commonFunctions.handleErrorResponse(error, this.toastr);
      },
    });
  }
}
